import React from 'react';
import PropTypes from 'prop-types';

export const RadioButton = ({ id, name, labelText, description, disabled, isChecked, handleSelection }) => (
    <label
        htmlFor={id}
        className={`download-radio-button ${isChecked && !disabled ? 'border-primary' : 'border-secondary'}`}
        onClick={handleSelection}
        disabled={isChecked}
    >
        <div className='d-flex justify-content-between align-items-center'>
            <h6 className='text-muted'>{labelText}</h6>
            <input
                id={id}
                name={name}
                type="radio"
                checked={isChecked}
                disabled={disabled}
                onChange={handleSelection}
                readOnly={disabled}
            />
        </div>
        <p>{description}</p>
    </label>
);

RadioButton.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    labelText: PropTypes.string.isRequired,
    description: PropTypes.object,
    disabled: PropTypes.bool.isRequired,
    isChecked: PropTypes.bool.isRequired,
    handleSelection: PropTypes.func.isRequired
};
